import React, { ReactNode } from 'react';

import { GradientDot, IconLightning } from '@trqk/components';

import { CardWrapper } from '../..';
import { mainIconWidth, mainGradientDotWidth } from '../../../constants';

interface DataCardProps {
    children: ReactNode;
    color: 'primary' | 'secondary' | 'tertiary' | 'quarternary';
    header: ReactNode;
    Icon: IconComponent;
    inInsightsIndex: boolean;
    title: string;
    wrapperId?: string;
}

/**
 * A wrapper for an Insights card that displays data visualization.
 */
export const DataCard = ({
    children,
    color,
    header,
    Icon,
    inInsightsIndex,
    title,
    wrapperId,
}: DataCardProps): JSX.Element => (
    <CardWrapper id={wrapperId}>
        <div className="absolute">
            <div className="relative" style={{ top: 20, left: 20 }}>
                {inInsightsIndex && (
                    <IconLightning fillColor="primary-500" width={24} />
                )}
            </div>
        </div>
        <div className="flex h-full flex-col justify-start">
            <div className="flex-none flex flex-col items-center justify-start mt-8 mb-5">
                <GradientDot width={mainGradientDotWidth} gradientColor={color}>
                    <Icon width={mainIconWidth} fillColor={`${color}-500`} />
                </GradientDot>
                <h4 className="mt-4 mb-2">{title}</h4>
                <div className="mx-4 text-center">{header}</div>
            </div>
            <div className="flex-none w-full">{children}</div>
        </div>
    </CardWrapper>
);
